import { GetUnformattedNumber, GetFormattedNumber } from '../../utils';

const GetParkingRegisters = unformattedData => {

  let formattedData =  [{
    name: 'Bici',
    unformattedName: 'bici',
    icon: 'fas fa-biking',
  }, {
    name: 'Carro',
    unformattedName: 'carro',
    icon: 'fas fa-car',
  }, {
    name: 'Moto',
    unformattedName: 'moto',
    icon: 'fas fa-motorcycle',
  }, {
    name: 'Monopatín',
    unformattedName: 'monopatin',
    icon: 'fas fa-snowboarding',
  }] 
  
  formattedData = formattedData.map(vehicleStructure => {
    const unformattedStructure = unformattedData[vehicleStructure.unformattedName];
    return {
      name: vehicleStructure.name,
      icon: vehicleStructure.icon,
      totalDays: `${unformattedStructure.length} ${unformattedStructure.length === 1 ? 'Día' : 'Días'}`,
      totalMoney: CalculateTotalMoneyByVehicleType(vehicleStructure.unformattedName, unformattedStructure),
      moneyType: GetMoneyTypeByVehicleType(vehicleStructure.unformattedName),
      list: unformattedStructure.map(register => ({
        date: register.date,
        price: register.price,
      })),
    }
  });

  return formattedData;

};


function CalculateTotalMoneyByVehicleType(type, unformattedStructure)  {

  let total = 0;


  if ((type === 'bici' || type === 'monopatin' || type === 'carro') && unformattedStructure.length > 14 ) {
    total = 150000;
  } else if (type === 'moto' && unformattedStructure.length > 14) {
    total = 75000;
  } else {
    unformattedStructure.forEach(({ price }) => {
      const unformattedValue = GetUnformattedNumber(price);
      total += unformattedValue;
    });
  }

  return GetFormattedNumber(String(total));


}

function GetMoneyTypeByVehicleType(type) {
  if (type === 'bici' || type === 'monopatin') {
    return 'tu beneficio';
  }
  return 'el valor del parqueadero';
}

export default GetParkingRegisters;